import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './Contact.css';

const contactMethods = [
    {
        title: 'Call Support',
        detail: '+91 96209 81400',
        href: 'tel:+919620981400',
        // note: 'For property enquiries and reservations',
    },
    {
        title: 'Call Support',
        detail: '+91 63666 99999',
        href: 'tel:+916366699999',
        // note: 'For follow-up help and booking assistance',
    },
];

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="contact-page">
            <SEO
                title="Contact Us | The Rent Company"
                description="Get in touch with The Rent Company for property enquiries, reservations, and support."
                path="/contact"
            />
            <Navbar />

            <main className="contact-main">
                <section className="contact-hero">
                    <div className="contact-hero-inner">
                        <div className="contact-copy">
                            <span className="contact-eyebrow">Contact Us</span>
                            <h1>Talk to our team directly.</h1>
                            <p>
                                If you want to reserve a property or need help shortlisting the right
                                home, call us directly. We keep the process simple and fast.
                            </p>
                        </div>

                        <div className="contact-hours-card">
                            <div className="contact-hours-label">Support Hours</div>
                            <div className="contact-hours-value">10:00 AM to 10:00 PM</div>
                            <p>Daily assistance for property search, reservation, and follow-up support.</p>
                        </div>
                    </div>
                </section>

                <section className="contact-methods">
                    {contactMethods.map((item) => (
                        <a className="contact-method-card" href={item.href} key={item.detail}>
                            <div className="contact-icon-wrap">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.63 2.62a2 2 0 0 1-.45 2.11L8 9.91a16 16 0 0 0 6.09 6.09l1.46-1.27a2 2 0 0 1 2.11-.45c.84.3 1.72.51 2.62.63A2 2 0 0 1 22 16.92z"></path>
                                </svg>
                            </div>
                            <div className="contact-method-body">
                                <div className="contact-method-title">{item.title}</div>
                                <div className="contact-method-number">{item.detail}</div>
                                <p>{item.note}</p>
                            </div>
                        </a>
                    ))}
                </section>

                <section className="contact-process">
                    <div className="contact-process-copy">
                        <span className="contact-eyebrow">What Happens Next</span>
                        <h2>View, call, reserve, done.</h2>
                        <p>
                            Once you find a property you like, call us. We help with availability,
                            reservation, and the next steps so you do not have to manage the process alone.
                        </p>
                    </div>

                    <div className="contact-process-grid">
                        <div className="contact-step">
                            <strong>1</strong>
                            <span>View properties on the website</span>
                        </div>
                        <div className="contact-step">
                            <strong>2</strong>
                            <span>Call our team to reserve</span>
                        </div>
                        <div className="contact-step">
                            <strong>3</strong>
                            <span>We handle the coordination</span>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default Contact;
